module.exports = __webpack_public_path__ + "static/media/Bg-iphone1.dcf1281e.png";